var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Paper, TextField, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useGenres } from "frontend/src/domain/genres";
var useStyles = makeStyles({
    inputBox: {
        "& > .MuiFormControl-root": {
            display: "flex",
        },
    },
});
var useSearchTerm = function () {
    var _a = __read(React.useState(""), 2), term = _a[0], setTerm = _a[1];
    var onChange = function (evt) {
        return setTerm(evt.target.value);
    };
    return { value: term, onChange: onChange };
};
var usePageGenres = function () {
    var data = useGenres().genres;
    var _a = __read(React.useState([]), 2), genres = _a[0], setGenres = _a[1];
    var onToggle = function (id) {
        return setGenres(genres.map(function (genre) {
            return genre.id === id ? __assign(__assign({}, genre), { checked: !genre.checked }) : genre;
        }));
    };
    React.useEffect(function () {
        if (data) {
            setGenres(data.map(function (genre) { return (__assign(__assign({}, genre), { checked: false })); }));
        }
    }, [data]);
    return { entries: genres, onToggle: onToggle };
};
export var useSearchCatalogForm = function () {
    var term = useSearchTerm();
    var genres = usePageGenres();
    var _a = __read(React.useState({ search: "", genres: [] }), 2), params = _a[0], setParams = _a[1];
    var onSubmit = function (evt) {
        evt.preventDefault();
        setParams({
            search: term.value,
            genres: genres.entries
                .filter(function (genre) { return genre.checked; })
                .map(function (genre) { return genre.id; }),
        });
    };
    return { term: term, genres: genres, params: params, onSubmit: onSubmit };
};
export var SearchTrackCatalogForm = function (_a) {
    var term = _a.term, genres = _a.genres, onSubmit = _a.onSubmit;
    var classes = useStyles();
    return (React.createElement("form", { onSubmit: onSubmit },
        React.createElement(Box, { component: Paper, p: 2 },
            React.createElement(Box, { display: "flex" },
                React.createElement(Box, { className: classes.inputBox, flexGrow: 1, mr: 2 },
                    React.createElement(TextField, { label: "Название", value: term.value, onChange: term.onChange })),
                React.createElement(Box, { display: "flex", alignItems: "flex-end" },
                    React.createElement(Button, { variant: "contained", color: "primary", type: "submit" }, "\u0418\u0441\u043A\u0430\u0442\u044C"))),
            React.createElement(Box, { mt: 4 },
                React.createElement(FormControl, { component: "fieldset" },
                    React.createElement(FormLabel, { component: "small" }, "\u0416\u0430\u043D\u0440\u044B"),
                    React.createElement(FormGroup, { row: true },
                        React.createElement(Box, { mt: 1 }, genres.entries.map(function (_a) {
                            var id = _a.id, title = _a.title, checked = _a.checked;
                            return (React.createElement(FormControlLabel, { key: id, control: React.createElement(Checkbox, { checked: checked, size: "small", color: "primary", onChange: function (evt) { return genres.onToggle(id); } }), label: title }));
                        }))))))));
};
